<template>
  <div class="hot-tabs">
    <div class="tab">
      <div
        v-for="(item,index) in category_all"
        :key="item.id + item.name"
        class="tab-item"
        :class="index==active_index?'active':''"
        :style="{'max-width':100/category_all.length+'%'}"
      >
        <button @click="active_index=index">
          <h4 class="text-overflow-2">{{cate_items && cate_items.length>0 && cate_items[index] && cate_items[index].title || item.name}}</h4>
        </button>
      </div>
      <div class="slider"></div>
    </div>
    <template v-if="cate_items && cate_items.length>0 && cate_items[active_index] && cate_items[active_index].layouts =='grid'">
      <div class="row p-1-7d5" v-if="category_all.length">
        <div class="p-1-7d5 p-md-1-10" v-for="list in products.slice(0,cate_items[active_index].limit_amount || 24)" :key="list.ID" :class="[colGrid(cate_items[active_index].row_amount),mbColGrid(cate_items[active_index].mb_row_amount)]">
          <v-product-card
            :disable_select="disable_select"
            :show_currency_selector="show_currency_selector"
            :cart_type="cart_type"
            :text_align="text_align"
            :product_price="product_price"
            :card_radio="card_radio"
            card_animate="vogue-am"
            :buy_button_style="buy_button_style"
            :sales_label="sales_label"
            :productDetail="list"
            :sale_image="sale_image"
            :show_star="show_star"
            :custom_button="list.custom_button&&list.custom_button.custom_button"
            model="is_card"
            :palette_config="palette_config"
            :keys="keys"
            :theme="theme"
            combination_position="products"
          ></v-product-card>
        </div>
      </div>
    </template>
    <template v-if="cate_items && cate_items.length>0 && cate_items[active_index] && cate_items[active_index].layouts =='slide' && products.length">
      <!-- 备选方案渲染banner -->
      <v-hot-banner
        :count="cate_items[active_index].row_amount || 3"
        :centeredSlides="true"
        :disable_select="disable_select"
        :show_currency_selector="show_currency_selector"
        :cart_type="cart_type"
        :text_align="text_align"
        :product_price="product_price"
        :card_radio="card_radio"
        card_animate="vogue-am"
        :products="products.length?JSON.stringify(products.slice(0,cate_items[active_index].limit_amount || 24)):'[]'"
        :buy_button_style="buy_button_style"
        :sales_label="sales_label"
        :sale_image="sale_image"
        :show_star="show_star"
        model="is_card"
        :palette_config="palette_config"
        :keys="keys"
        :theme="theme"
      ></v-hot-banner>
    </template>
    <a href="/collections" class="morebtn" v-if="cate_items && cate_items.length>0 && cate_items[active_index] && cate_items[active_index].more_button && cate_items[active_index].more_button.text">
        <button 
        :style="{
         color:cate_items[active_index].more_button.text_color || '#fff',
         backgroundColor:cate_items[active_index].more_button.background_color || '#000'
        }"
        >
          {{cate_items[active_index].more_button.text}}
        </button>
    </a>
  </div>
</template>

<script>
// import API from "../../../../js/API";
export default {
  props: [
    "category_id",
    "tabs_layouts",
    "col",
    "custom_button",
    "model",
    "palette_config",
    "font_size",
    "sale_image_show",
    "show_star",
    "sale_image",
    "disable_select",
    "show_currency_selector",
    "cart_type",
    "text_align",
    "product_price",
    "card_radio",
    "card_animate",
    "buy_button_style",
    "sales_label",
    "keys",
    "count",
    "tab_category_id",
    "theme",
    "cate_items",
  ],
  data() {
    return {
      category_all: [],
      active_index: null,
      products: []
    };
  },
  methods: {
    active() {
      this.products = this.category_all[this.active_index].posts;
      let width = this.$(".hot-tabs .active").width();
      let left =
        this.$(".hot-tabs .active").position().left +
        parseInt(this.$(".hot-tabs .active").css("marginLeft"));
      this.$(".hot-tabs .slider")
        .css("width", width)
        .css("left", left);
    },
    colGrid(count) {
       let col='col-md-3';
       switch (count) {
            case 2:
                col = 'col-md-6';
                break;
            case 3:
                col = 'col-md-4';
                break;
            case 4:
                col = 'col-md-3';
                break;
            case 5:
                col = 'col-md-1-5';
                break;
            case 6:
                col = 'col-md-2';
                break;
            default:
                col = 'col-md-3';
                break;
       }
       return col;
    },
    mbColGrid(count) {
       let col='col-6';
       switch (count) {
            case 1:
                col = 'col-12';
                break;
            case 2:
                col = 'col-6';
                break;
            default:
                col = 'col-6';
                break;
       }
       return col;
    }
  },
  beforeMount() {
    let arr = [];
    this.tab_category_id.forEach(id => {
      let p = new Promise((resolve, reject) => {
        this.$axios.get(API.categories + id).then(res => {
          resolve(res.data);
        });
      });
      arr.push(p);
    });
    Promise.all([...arr]).then(res => {
      this.category_all = res;
      this.active_index = 0;
      console.log(this.category_all);
    });

    console.log(this.tab_category_id, this.tabs_layouts,this.cate_items,'cate_items' );
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.active_index = 0;
    // });
  },
  watch: {
    active_index(newV) {
      this.$nextTick(this.active);
    }
  }
};
</script>

<style lang="scss" scoped>
.hot-tabs {
  .tab {
    position: relative;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 36px;
    border-bottom: 2px solid rgb(211, 212, 213);
    .tab-item {
      margin: 0px 36px;
      button {
        background-color: transparent;
        cursor: pointer;
        border: none;
        padding: 0px 30px 12px;
        transform: translateY(2px);
        outline: inherit;
      }
      h4 {
        font-weight: 700;
        font-size: 16px;
        line-height: 1.5;
        letter-spacing: 2px;
        color: rgb(33, 42, 47);
        margin: 0px;
        padding: 0px;
      }
      .active {
        opacity: 1;
        transition: opacity 250ms ease 0s;
        border-bottom: none;
      }
    }
    .slider {
      position: absolute;
      bottom: 0px;
      display: block;
      transform: translateY(2px);
      background-color: black;
      height: 2px;
      transition: all 250ms ease-out 0s;
    }
  }
  .morebtn {
      display: block;
      text-align: center;
      button {
        padding: 18px 38px;
        font-size: 16px;
      } 
  }
}
@media (max-width: 767px) {
  .hot-tabs {
    .tab {
      justify-content: space-between;
      .tab-item {
        margin: 0px;
        width: 100%;
        text-align: center;
        
        button {
          padding: 0px 0px 6px;
          h4 {
            font-size: 13px;
          }
        }
      }
    }
    .morebtn {
      button {
        padding: 14px 30px;
        font-size: 13px;
      } 
    }
  }
}
</style>